<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Modelo: </span>
      <span>{{entidade.nome}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{entidade.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome: </label>
      <div class="p-col-12 p-md-10">{{entidade.nome}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Domínio: </label>
      <div class="p-col-12 p-md-10">{{entidade.dominio}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Versão: </label>
      <div class="p-col-12 p-md-10">{{entidade.versao}}</div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>
